export default __webpack_public_path__ + "static/media/GR5 3A-1D-1E-2EC.c0650797.jpg";